module.exports = __webpack_public_path__ + "img/04.7c2d06a1.jpg";